import { render, staticRenderFns } from "./ShortageMark.vue?vue&type=template&id=592ed5ed&lang=pug&"
import script from "./ShortageMark.vue?vue&type=script&lang=js&"
export * from "./ShortageMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports